import styled from 'styled-components';

export const FacialPhotoWrapper = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    height: 1px;
    width: 100%;
    background: linear-gradient(
      to right,
      transparent 10%,
      ${({ theme, $textColor }) => $textColor || theme.colors.white} 20%,
      ${({ theme, $textColor }) => $textColor || theme.colors.white} 80%,
      transparent 90%
    );
    mask-image: repeating-linear-gradient(
      to right,
      transparent,
      transparent 4px,
      black 4px,
      black 6px
    );
    -webkit-mask-image: repeating-linear-gradient(
      to right,
      transparent,
      transparent 4px,
      black 4px,
      black 6px
    );
    z-index: 0;
  }
`;

export const FacialCheck = styled.div`
  position: relative;
  width: 52px;
  height: 52px;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const FacialPhoto = styled.img`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0;
  animation: fadeIn 0.4s ease-in-out 0.1s forwards;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const FacialPhotoSkeleton = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(
    90deg,
    ${props => props.theme.colors.blackShades(0.05)} 25%,
    ${props => props.theme.colors.blackShades(0.1)} 50%,
    ${props => props.theme.colors.blackShades(0.05)} 75%
  );
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;

export const CheckBadge = styled.div`
  position: absolute;
  top: -2px;
  right: -2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.colors.green500};
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  z-index: 2;

  svg {
    color: ${props => props.theme.colors.white};
    font-size: 14px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
`;

export const WelcomeText = styled.h2`
  margin: 0 28px 16px;
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme, $textColor }) => $textColor || theme.colors.white};
  line-height: 1.2;
`;

export const UpdatePrompt = styled.a`
  margin: 0;
  font-size: 14px;
  color: ${({ theme, $textColor }) => $textColor || theme.colors.white};
  font-weight: 400;
  line-height: 1.2;
  cursor: pointer;
  text-decoration: none;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
    color: ${({ theme, $textColor }) => $textColor || theme.colors.white};
  }
`;
